module.exports = __webpack_public_path__ + "img/5_46.372ae3ce.png";